/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EnrollmentListItemCancelledReason } from './enrollmentListItemCancelledReason';
import type { EnrollmentListItemResolvedEmailType } from './enrollmentListItemResolvedEmailType';
import type { EnrollmentListItemSendPhase } from './enrollmentListItemSendPhase';
import type { EnrollmentListItemStatus } from './enrollmentListItemStatus';
import type { EnrollmentListItemWaterfallStrategy } from './enrollmentListItemWaterfallStrategy';

/**
 * Slim row for the Enrollments tab table.
 */
export interface EnrollmentListItem {
  id: string;
  sequence_id: string;
  job_id: string;
  job_candidate_id: string;
  profile_id: string;
  full_name?: string | null;
  avatar_url?: string | null;
  stage_name?: string | null;
  stage_color?: string | null;
  reply_classification?: string | null;
  reply_classified?: boolean;
  status: EnrollmentListItemStatus;
  /** @minimum 0 */
  current_step_index: number;
  /** @minimum 0 */
  step_count?: number;
  next_due_at?: string | null;
  current_step_type?: string | null;
  send_phase?: EnrollmentListItemSendPhase;
  last_event_at?: string | null;
  started_at?: string | null;
  completed_at?: string | null;
  cancelled_at?: string | null;
  cancelled_reason?: EnrollmentListItemCancelledReason;
  failure_code?: string | null;
  failure_detail?: string | null;
  /** @minimum 0 */
  failure_count?: number;
  last_failure_at?: string | null;
  paused_reason?: string | null;
  last_resume_attempt_at?: string | null;
  sender_user_id: string;
  mailbox_id?: string | null;
  linkedin_account_id?: string | null;
  waterfall_strategy: EnrollmentListItemWaterfallStrategy;
  resolved_email?: string | null;
  resolved_email_type?: EnrollmentListItemResolvedEmailType;
  /** @minimum 0 */
  messages_sent_count?: number;
  /** @minimum 0 */
  replies_received_count?: number;
  /** @minimum 0 */
  opens_count?: number;
  /** @minimum 0 */
  clicks_count?: number;
  /** @minimum 0 */
  bounced_count?: number;
  created_at: string;
  updated_at: string;
}
